<template>
  <div class="production_wrap">
    <div
        class="production_img"
        v-if="hiddenProdFive1"
        :style="{ background: `url(${prodOne.image}) 0 0 no-repeat`, backgroundSize: '100%' }"
    >
      <div class="img_tit">{{ prodOne.title }}</div>
      <div class="img_desc">{{ prodOne.subtitle }}</div>
    </div>

    <div class="prod-container">
      <!-- 左侧菜单 -->
      <div class="left-menu">
        <div class="menu-title-box">
          <div class="menu-title">PRODUCTS</div>
          <div class="menu-toggle-btn" @click="menuCollapsed = !menuCollapsed">
            {{ menuCollapsed ? '+' : '×' }}
          </div>
        </div>

        <div class="menu-slide-box" :class="menuCollapsed ? 'slide-close' : ''">
          <div
              class="menu-item"
              :class="{ active: currentPath === item.routePath, last: index === productMenus.length-1 }"
              @click="goMenu(item)"
              v-for="(item, index) in productMenus"
              :key="item.id"
          >
            {{ item.menuName }}
          </div>
        </div>
      </div>

      <!-- 右侧产品 -->
      <div class="right-content">
        <div class="product-grid">
          <div
              class="product-card"
              v-for="item in prodList"
              :key="item.productNo"
              @click="goDetail(item.productNo)"
          >
            <div class="card-img">
              <img :src="item.mainImage" alt="" />
            </div>
            <div class="card-name">{{ item.productName }}</div>
          </div>
        </div>
      </div>
    </div>

    <CallMe />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import { leftLikeDict, getMenuFrontTree, getProductList } from '../../api/system'
import { findDictHidden, findMainProp } from '../../utils'
import Constant from '../../utils/Constant'

export default {
  data() {
    return {
      hiddenProdFive1: true,
      prodOne: {},
      productMenus: [],
      prodList: [],
      currentPath: '',
      menuCollapsed: true
    }
  },
  components: {
    CallMe,
  },
  methods: {
    async leftLikeDictFunc() {
      try {
        const res = await leftLikeDict(Constant.PROD_FIVE1);
        if (res.data) {
          this.prodOne = findMainProp(res.data.data, Constant.PROD_FIVE1)
          this.hiddenProdFive1 = findDictHidden(Constant.PROD_FIVE1, res.data.data)
        }
      } catch (e) {}
    },
    async getProductMenu() {
      try {
        const res = await getMenuFrontTree()
        if (res.data.code === 200) {
          const parent = res.data.data[1]
          this.productMenus = parent?.children || []
        }
      } catch (e) {}
    },
    async getProductList() {
      try {
        const res = await getProductList("5")
        if (res.data.code === 200) {
          this.prodList = res.data.data || []
        }
      } catch (e) {}
    },
    goMenu(item) {
      this.$router.push({path: item.routePath})
    },
    goDetail(productNo) {
      this.$router.push('/production/detail?productNo=' + productNo)
    },
    updateActiveMenu() {
      this.currentPath = this.$route.path
    }
  },
  mounted() {
    this.leftLikeDictFunc()
    this.getProductMenu()
    this.getProductList()
    this.updateActiveMenu()
  },
  watch: {
    $route: 'updateActiveMenu'
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;

  .production_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 22px;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 16px;
      }
    }
  }

  .prod-container {
    display: flex;
    width: 100%;
    max-width: 100%;
    margin: 40px 0;
    padding: 0 20px;
    gap: 20px;
    box-sizing: border-box;
    align-items: flex-start;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0 15px;  // 把这里改成 左右留白 15-20px
      margin: 30px 0 0;
    }
  }

  .left-menu {
    width: 20%;
    border: 1px solid #eee;
    padding: 0;
    background: #fff;
    position: relative;
    z-index: 1;
    align-self: flex-start;
    font-family: 'Roboto_Bold', sans-serif;
    @media (max-width: 768px) {
      width: 100%;
    }

    .menu-title-box {
      background: #992667;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .menu-title {
        color: #fff;
        font-size: 22px;
        padding: 16px 20px;
        margin: 0;
        box-sizing: border-box;
        font-weight: bold;

        @media (max-width: 768px) {
          font-size: 18px;
          padding: 10px 20px; /* 👈 加高标题栏，让文字和图标不挤 */
        }
      }

      .menu-toggle-btn {
        color: #fff;
        font-size: 24px;
        font-weight: bold;
        padding: 16px 20px;
        cursor: pointer;
        user-select: none;
        display: none;

        @media (max-width: 768px) {
          display: block;
          font-size: 22px;
          padding: 10px 20px; /* 👈 按钮和标题栏同高 */
        }
      }
    }

    .menu-slide-box {
      max-height: 3000px; /* 默认收起高度 */
      overflow: hidden;
      transition: max-height 0.4s ease-out;
    }
    .menu-slide-box:not(.slide-close) {
      max-height: 2200px; /* 展开最大高度，足够放下所有菜单 */
    }
    .menu-slide-box.slide-close {
      @media (max-width: 768px) { /* 👈 只在移动端生效收起 */
        max-height: 0;
      }
    }

    .menu-item {
      padding: 16px 20px;
      border-bottom: 1px solid #eee;
      font-size: 18px;
      cursor: pointer;
      transition: all 0.3s;
      color: #333;
      background: #fff;
      display: block;
      width: 100%;
      box-sizing: border-box;
      text-align: left;
      font-weight: bold;

      @media (max-width: 768px) {
        font-size: 15px; /* 👈 缩小菜单项文字 */
        padding: 10px 20px;
      }

      &.last {
        border-bottom: none !important;
      }

      &:hover {
        background: #f8f8f8;
      }

      &.active {
        color: #992667;
        font-weight: bold;
        background: #fff;
      }
    }
  }

  .right-content {
    flex: 1;
    padding: 0;
    @media (max-width: 768px) {
      width: 100%;
      margin-top: 25px;
    }
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 22px;
    width: 100%;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 15px;
      padding: 0;
      margin: 0;
    }
  }

  .product-card {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    width: 100%;
    border: 1px solid #cecccc;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      border-radius: 0; /* 👈 移动端去掉圆角，让产品撑满 */
      //border-left: none;
      //border-right: none;
    }

    .card-img {
      width: 100%;
      height: 450px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background-color: #fff;

      @media (max-width: 768px) {
        height: 360px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        transition: transform 0.3s ease;
      }
    }

    .card-name {
      width: 100%;
      height: 80px;
      background: #3a3d51;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      font-size: 18px;
      text-align: center;
      transition: background 0.3s ease;
      box-sizing: border-box;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;

      @media (max-width: 768px) {
        height: 70px;
        font-size: 16px;
      }
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);

      .card-img img {
        transform: scale(1.05);
      }

      .card-name {
        background: #992667;
      }
    }
  }
}
</style>